var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.06667 12.1333C9.86492 12.1333 12.1333 9.86492 12.1333 7.06667C12.1333 4.26843 9.86492 2 7.06667 2C4.26843 2 2 4.26843 2 7.06667C2 9.86492 4.26843 12.1333 7.06667 12.1333Z",
    stroke: "#4F5662"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06654 4.53333C6.39466 4.53333 5.75029 4.80023 5.2752 5.27532C4.80011 5.75042 4.5332 6.39478 4.5332 7.06666M14.6666 14.6667L12.1332 12.1333",
    stroke: "#4F5662",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.60513ec2c2f31b60fa4dfa5dfe958264.svg";
export { ForwardRef as ReactComponent };